import { useContext } from "react";
import { ChatUIContext } from "../context/ChatUIContext.js";
const useChatUIContext = ()=>{
    const context = useContext(ChatUIContext);
    if (!context) throw new Error('useUIContext must be used within a UIContextProvider');
    return context;
};
export { useChatUIContext };
